import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/Button";
import { SOCIAL_LINKS } from "@/utils/constants";
import { cn } from "@/utils/helpers";
import { type MouseEvent } from "react";
interface SocialLinksProps {
  containerClassName?: string;
  buttonClassName?: string;
  ariaLabel?: string;
}
const handleSocialClick = (e: MouseEvent<HTMLButtonElement>, link: string) => {
  e.stopPropagation();
  if (link.startsWith("mailto:")) {
    window.location.assign(link);
  } else {
    window.open(link, "_blank", "noopener,noreferrer");
  }
};
export const SocialLinks = t0 => {
  const $ = _c(8);
  const {
    containerClassName,
    buttonClassName,
    ariaLabel
  } = t0;
  let t1;
  if ($[0] !== containerClassName) {
    t1 = cn("flex gap-3", containerClassName);
    $[0] = containerClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== buttonClassName) {
    t2 = SOCIAL_LINKS.map(t3 => {
      const {
        id,
        url,
        icon: Icon,
        ariaLabel: ariaLabel_0
      } = t3;
      return <Button key={id} onClick={e => handleSocialClick(e, url)} variant="secondary" isIcon={true} icon={<Icon className="w-5 h-5" />} aria-label={ariaLabel_0} className={buttonClassName} />;
    });
    $[2] = buttonClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== t1 || $[6] !== t2) {
    t3 = <nav className={t1} aria-label={ariaLabel}>{t2}</nav>;
    $[4] = ariaLabel;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};